import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import MainContainer from '../../../components/MainContainer';
import BookingSubCategoryListPage from './BookingSubCategoryList';
import BookingSubCategoryModalPage from './BookingSubCategoryModal';
import BookingSubCategorySearchModal from './BookingSubCategorySearchModal';
import './BookingSubCategory.css';

@inject(
    'loginStore',
    'BookingSubCategoryStore'
)
@observer
class BookingSubCategoryPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
    }

    // ON CANCEL

    bookingSubCategoryModalOnCancel = () => {
        this.props.BookingSubCategoryStore.setShowBookingSubCategoryModal(false);
    }

    bookingSubCategorySearchModalOnCancel = () => {
        this.props.BookingSubCategoryStore.setShowBookingCategorySearchModal(false);
    }

    render() {
        const { t } = this.props;
        const {
            showBookingSubCategoryModal,
            bookingSubCategoryTitle,
            showBookingCategorySearchModal
        } = this.props.BookingSubCategoryStore;

        return (
            <MainContainer title={t('Booking Sub Category')} menukey='booking-sub-category'>
                <Modal
                    title={t(bookingSubCategoryTitle)}
                    visible={showBookingSubCategoryModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingSubCategoryModalOnCancel}
                    zIndex={1000}
                >
                    <BookingSubCategoryModalPage />
                </Modal>

                <Modal
                    title={t("Search Category")}
                    visible={showBookingCategorySearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.bookingSubCategorySearchModalOnCancel}
                    zIndex={2000}
                >
                    <BookingSubCategorySearchModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <BookingSubCategoryListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingSubCategoryPage);
